import React, { useState, useRef, useEffect  } from 'react'
import '../css/integracionLogistica.css'
import '../css/multimodal.css'
import contractLogistics from '../assets/images/soluciones/integracion/contract-logistics.png'
import freight_forwarding from '../assets/images/carga/terrestre/freight-forwarding.webp'
import { Outlet } from "react-router-dom";
import FooterCarga from '../components/FooterCarga'
import video from '../assets/video/integracionLogistica.mp4';
import solucioneslogisitcas from '../assets/images/soluciones/video-solucioneslogisitcas.png'

import intermodal from '../assets/images/carga/multimodal/intermodal.webp'
import { useTranslation } from 'react-i18next';
import MapaTopo from '../components/maps/MapaTopo'

import HeaderCarga from '../components/HeaderCarga';

import embarque from '../assets/images/soluciones/integracion/multimodal/maritimo-blue.svg'
import ambiente from '../assets/images/soluciones/integracion/multimodal/sustentable-blue.svg'
import robo from '../assets/images/soluciones/integracion/multimodal/menosrobos-blue.svg'
import puerta from '../assets/images/soluciones/integracion/multimodal/puertapuerta-blue.svg'
import punto_contacto from '../assets/images/soluciones/integracion/multimodal/puntodcontacto-blue.svg'
import terrestre from '../assets/images/soluciones/integracion/multimodal/terrestre-blue.svg'
import eficiencia from '../assets/images/soluciones/integracion/multimodal/eficiencia-blue.svg'
import menor_riesgo from '../assets/images/soluciones/integracion/multimodal/menosaccidentes-blue.svg'
import documento from '../assets/images/soluciones/integracion/multimodal/documento-blue.svg'
import rastreabilidad from '../assets/images/soluciones/integracion/multimodal/rastreabilidad-blue.svg'

import multimodal1 from '../assets/images/soluciones/integracion/multimodal01.png'
import multimodal2 from '../assets/images/soluciones/integracion/multimodal02.png'
import multimodal3 from '../assets/images/soluciones/integracion/multimodal03.png'
import integracion from '../assets/images/soluciones/integracion/integracion.png'


export default function IntegracionLogistica() {
    const { t } = useTranslation('integracionLogistica');
    const [isPlaying, setIsPlaying] = useState(false);
    const [isButtonVisible, setIsButtonVisible] = useState(true);
    const videoRef = useRef(null);

    const handlePlayPause = () => {
        if (isPlaying) {
            videoRef.current.pause();
        } else {
            videoRef.current.play();
        }
        setIsPlaying(!isPlaying);
    };

    useEffect(() => {
        if (isButtonVisible) {
            const timer = setTimeout(() => {
                setIsButtonVisible(false);
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [isButtonVisible]);

 
  return (
    <>
    <HeaderCarga />
   
    <section className='header_carga integracion'>
        <div className='container'>
            <div className='servicio_carga_header'>
                <div className='servicio_carga_box'>
                    <h2>{t('integracion')}</h2>
                    <p>{t('integracion_p')}</p>
                </div>
            </div>
        </div>
    </section>

    <section className='servicio_carga'>
        <div className='container'>
            <div className='servicio_carga_content'>                
                <div className='servicio_carga_box chartering text'>
                    <h2>{t('text7')}</h2>
                    <p>{t('text1')}</p>  
                    <p>Nuestra logística representa un nivel avanzado de integración y gestión logística, utilizando tecnología de punta y un enfoque estratégico para ofrecer soluciones logísticas completas, eficientes y sostenibles.</p>
                    <p>A diferencia de los otros modelos de logística que se enfocan en aspectos específicos como el transporte, almacenamiento, y gestión de operaciones, un proveedor 5PL mira la cadena de suministro desde una perspectiva más amplia y estratégica.</p>               
                    <div className='btn_servicio_transporte'>
                        <a href="mailto:ailyn.flores@bajaferries.com.mx" rel="noopener noreferrer">{t('text6')}</a>                                              
                    </div>
                </div>
               {/*} <div className='servicio_carga_box ilvideo img'>
                    <video ref={videoRef} loop width="100%" height="500" poster={solucioneslogisitcas}>
                        <source src={video} type="video/mp4" />
                    </video>
                    <div className='btn-controls-video'>
                        <button className={`play-pause-button ${isButtonVisible ? 'button-visible' : 'button-hidden'}`} onClick={handlePlayPause}>
                            {isPlaying ? (<i class="fi fi-ss-pause"></i>):(<i class="fi fi-ss-play"></i>)}
                        </button>
                    </div>                                      
                </div>*/}
                <div className='servicio_carga_box'>
                    <img src={integracion} alt='servicio multimodal baja ferries' />
                </div>
            </div>
        </div>
    </section>    

    <section className='servicio_carga'>
        <div className='container'>
            <div className='servicio_carga_content'> 
                <div className='servicio_carga_box'>
                    <img src={intermodal} alt='servicio multimodal baja ferries' />
                </div>
                <div className='servicio_carga_box feedering'>
                <h2>{t('text8')}  </h2>
                    <p>{t('text9')} </p>
                    <p>{t('text10')}</p>                    
                    <div className='btn_servicio_transporte'>                        
                        <a href="mailto:contacto.comercial@bajaferries.com.mx" rel="noopener noreferrer">{t('text6')}</a>                                                          
                    </div>
                </div>                
            </div>
        </div>
    </section>
    <section className='servicio_carga'>
        <div className='multimodal-cobertura'>
            <div className='container'>
            <div className='multimodal-cobertura-title'>
                    <h3>{t('text11')}</h3>
                </div>
                <div className='multimodal-cobertura-content'>
                    <div className='multimodal-cobertura-box'>
                        <div className='multimodal-cobertura-img'>
                            <i class="fi fi-bs-marker"></i>
                        </div>
                        <div className='multimodal-cobertura-text'>
                            <h3>MEXICALI</h3>
                            <ul>
                                <li>Tijuana, Ensenada</li>                                
                                <li>Tecate, San Diego</li>                                
                            </ul>
                        </div>
                    </div>
                    <div className='multimodal-cobertura-box'>
                        <div className='multimodal-cobertura-img'>
                            <i class="fi fi-bs-marker"></i>
                        </div>
                        <div className='multimodal-cobertura-text'>
                            <h3>HERMOSILLO</h3>
                            <ul>
                                <li>Guaymas</li>                                             
                            </ul>
                        </div>
                    </div>
                    <div className='multimodal-cobertura-box'>
                        <div className='multimodal-cobertura-img'>
                            <i class="fi fi-bs-marker"></i>
                        </div>
                        <div className='multimodal-cobertura-text'>
                            <h3>GUADALAJARA </h3>
                            <ul>
                                <li>Zona Metropolitana</li>
                                <li>Ciudad Guzmán</li>
                                <li>Colima</li>                            
                            </ul>
                        </div>
                    </div>
                    <div className='multimodal-cobertura-box'>
                        <div className='multimodal-cobertura-img'>
                            <i class="fi fi-bs-marker"></i>
                        </div>
                        <div className='multimodal-cobertura-text'>
                            <h3>PANTACO</h3>
                            <ul>
                                <li>CDMX y Zona Metropolitana</li>
                                <li>Puebla, Morelos</li>
                                <li>Hidalgo</li>
                                
                            </ul>
                        </div>
                    </div>
                    <div className='multimodal-cobertura-box'>
                        <div className='multimodal-cobertura-img'>
                            <i class="fi fi-bs-marker"></i>
                        </div>
                        <div className='multimodal-cobertura-text'>
                            <h3>SILAO </h3>
                            <ul>
                                <li>Zona Bajío, León</li>                                
                                <li>Querétaro, San Luis Potosí</li>                               
                            </ul>
                        </div>
                    </div>
                    
                </div>
            
        
            </div>
        </div>
    </section>
    <section className='servicio_carga'>
        <div className='map-multimodal'>
            <div className='container'>
                <div className='map-multimodal-content'>
                    <h2>{t('text12')} <br /> <strong>{t('text13')}</strong></h2>
                    <div className='map-multimodal-text'>
                        <div className='map-multimodal-text-box'>
                            <p><i class="fi fi-rr-circle-1"></i> {t('text14')}</p>
                            <p><i class="fi fi-rr-circle-2"></i> {t('text15')}</p>
                        </div>
                        <div className='map-multimodal-text-box'>
                            <p><i class="fi fi-rr-circle-3"></i> {t('text16')}</p>
                            <p><i class="fi fi-rr-circle-4"></i> {t('text17')}</p>
                            <p><i class="fi fi-rr-circle-5"></i> {t('text18')}</p>
                            <p><i class="fi fi-rr-circle-6"></i>{t('text19')}</p>
                        </div>
                    </div>
                    <div className='map-multimodal-box'>                
                        <MapaTopo />
                    </div>
                </div>

            </div>
        </div>
    </section>
    <section className='servicio_carga'>
        <div className='multimodal-ventajas'>
            <div className='container'>
                <div className='multimodal-ventajas_title'>
                    <h3>{t('text20')}</h3>
                </div>
                <div className='multimodal-ventajas-content'>
                    <div className='multimodal-ventajas-box'>
                        <div className='multimodal-ventajas-img'>
                            <img src={embarque} alt='' />
                        </div>
                        <div className='multimodal-ventajas-text'>
                            <h3>{t('text21')} </h3>
                        </div>
                    </div>
                    <div className='multimodal-ventajas-box'>
                        <div className='multimodal-ventajas-img'>
                            <img src={ambiente} alt='' />
                        </div>
                        <div className='multimodal-ventajas-text'>
                            <h3>{t('text22')}</h3>
                        </div>
                    </div>
                    <div className='multimodal-ventajas-box'>
                        <div className='multimodal-ventajas-img'>
                            <img src={robo} alt='' />
                        </div>
                        <div className='multimodal-ventajas-text'>
                            <h3>{t('text23')} </h3>
                        </div>
                    </div>
                    <div className='multimodal-ventajas-box'>
                        <div className='multimodal-ventajas-img'>
                            <img src={puerta} alt='' />
                        </div>
                        <div className='multimodal-ventajas-text'>
                            <h3>{t('text24')}</h3>
                        </div>
                    </div>
                    <div className='multimodal-ventajas-box'>
                        <div className='multimodal-ventajas-img'>
                            <img src={punto_contacto} alt='' />
                        </div>
                        <div className='multimodal-ventajas-text'>
                            <h3>{t('text25')} </h3>
                        </div>
                    </div>
                
                    <div className='multimodal-ventajas-box'>
                        <div className='multimodal-ventajas-img'>
                            <img src={terrestre} alt='' />
                        </div>
                        <div className='multimodal-ventajas-text'>
                            <h3>{t('text26')}</h3>
                        </div>
                    </div>
                    <div className='multimodal-ventajas-box'>
                        <div className='multimodal-ventajas-img'>
                            <img src={eficiencia} alt='' />
                        </div>
                        <div className='multimodal-ventajas-text'>
                            <h3>{t('text27')} </h3>
                        </div>
                    </div>
                    <div className='multimodal-ventajas-box'>
                        <div className='multimodal-ventajas-img'>
                            <img src={menor_riesgo} alt='' />
                        </div>
                        <div className='multimodal-ventajas-text'>
                            <h3>{t('text28')}</h3>
                        </div>
                    </div>
                    <div className='multimodal-ventajas-box'>
                        <div className='multimodal-ventajas-img'>
                            <img src={documento} alt='' />
                        </div>
                        <div className='multimodal-ventajas-text'>
                            <h3>{t('text29')}</h3>
                        </div>
                    </div>
                    <div className='multimodal-ventajas-box'>
                        <div className='multimodal-ventajas-img'>
                            <img src={rastreabilidad} alt='' />
                        </div>
                        <div className='multimodal-ventajas-text'>
                            <h3>{t('text30')}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    



    <section className='servicio_carga'>
        <div className='container'>
            
            <div className='sericio_carga_text'>
                <h2>{t('text31')} </h2>
                <p>{t('text32')}</p>
                <div className='btn_servicio_transporte solid'>                        
                    <a href="mailto:ulises.hernandez@bajaferries.com.mx" rel="noopener noreferrer">{t('text6')}</a>                                                       
                </div>
            </div>     
            <div className='service-box-img '>
                <div>
                    <img src={multimodal1} alt='servicio maritimo baja ferries' />
                </div>
                <div>
                    <img src={multimodal2} alt='servicio maritimo baja ferries' />
                </div>
                <div>
                    <img src={multimodal3} alt='servicio maritimo baja ferries' />
                </div>
            </div>                        
        
        </div>
    </section>
    {/*
    <section className='diseno_de_servicio'>
        <div className='container'>
            <div className='diseno_de_servicio_box'>
                <img src={multimodalImg} alt='Multimodal' />
            </div>
            
        </div>
    </section>
    */}
    <section className='servicio_carga'>
        <div className='container'>
            <div className='servicio_carga_content'> 
                <div className='servicio_carga_box img'>
                    <img src={contractLogistics} alt='servicio terrestre baja ferries' />
                </div>               
                <div className='servicio_carga_box feedering text'>
                    <h2>{t('text2')}  </h2>
                    <p>{t('text3')}</p>
                    <div className='btn_servicio_transporte'>                        
                    <a href="mailto:ailyn.flores@bajaferries.com.mx" rel="noopener noreferrer">{t('text6')}</a>                                                              
                    </div>
                </div>
                
            </div>
        </div>
    </section>
    <section className='servicio_carga'>
        <div className='container'>
            <div className='servicio_carga_content'>                
                <div className='servicio_carga_box proyecto text'>
                    <h2>{t('text4')}</h2>
                    <p>{t('text5')}</p>
                    <div className='btn_servicio_transporte'>                        
                    <a href="mailto:ailyn.flores@bajaferries.com.mx" rel="noopener noreferrer">{t('text6')}</a>                                                             
                    </div>
                </div>
                <div className='servicio_carga_box img'>
                    <img src={freight_forwarding} alt='servicio terrestre baja ferries' />
                </div>
            </div>
        </div>
    </section>

    <FooterCarga />
    <Outlet />
    
    </>
  )
}
